import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar recursos de tradução
import enCommon from './resources/en/common.json';
import enAuth from './resources/en/auth.json';
import enPacks from './resources/en/packs.json';
import enCategories from './resources/en/categories.json';
import enTags from './resources/en/tags.json';
import enLearnings from './resources/en/learnings.json';
import enProfiles from './resources/en/profiles.json';
import enAnalytics from './resources/en/analytics.json';
import enContracts from './resources/en/contracts.json';
import enHighlights from './resources/en/highlights.json';
import enCollections from './resources/en/collections.json';
import enPayments from './resources/en/payments.json';
import enReceivables from './resources/en/receivables.json';
import enReceivableShareConfigs from './resources/en/receivable-share-configs.json';
import enReceivableSnapshots from './resources/en/receivable-snapshots.json';
import enNavigation from './resources/en/navigation.json';
import enPresets from './resources/en/presets.json';
import enReceivablesComponents from './resources/en/receivables-components.json';
import enPaymentsComponents from './resources/en/payments-components.json';
import enLgpd from './resources/en/lgpd.json';
import enStoreRedirect from './resources/en/store-redirect.json';
import enCreatorFinancial from './resources/en/creator-financial.json';
import enBulkNotifications from './resources/en/bulk-notifications.json';
import enAdminFinancialOverview from './resources/en/admin-financial-overview.json';
import enDateRangePicker from './resources/en/date-range-picker.json';
import enDiscord from './resources/en/discord.json';
import enMailchimp from './resources/en/mailchimp.json';
import enPsdTemplates from './resources/en/psd-templates.json';
import enPsdTutorials from './resources/en/psd-tutorials.json';
import ptBRCommon from './resources/pt-BR/common.json';
import ptBRAuth from './resources/pt-BR/auth.json';
import ptBRPacks from './resources/pt-BR/packs.json';
import ptBRCategories from './resources/pt-BR/categories.json';
import ptBRTags from './resources/pt-BR/tags.json';
import ptBRLearnings from './resources/pt-BR/learnings.json';
import ptBRProfiles from './resources/pt-BR/profiles.json';
import ptBRAnalytics from './resources/pt-BR/analytics.json';
import ptBRContracts from './resources/pt-BR/contracts.json';
import ptBRHighlights from './resources/pt-BR/highlights.json';
import ptBRCollections from './resources/pt-BR/collections.json';
import ptBRPayments from './resources/pt-BR/payments.json';
import ptBRReceivables from './resources/pt-BR/receivables.json';
import ptBRReceivableShareConfigs from './resources/pt-BR/receivable-share-configs.json';
import ptBRReceivableSnapshots from './resources/pt-BR/receivable-snapshots.json';
import ptBRNavigation from './resources/pt-BR/navigation.json';
import ptBRPresets from './resources/pt-BR/presets.json';
import ptBRReceivablesComponents from './resources/pt-BR/receivables-components.json';
import ptBRPaymentsComponents from './resources/pt-BR/payments-components.json';
import ptBRLgpd from './resources/pt-BR/lgpd.json';
import ptBRStoreRedirect from './resources/pt-BR/store-redirect.json';
import ptBRCreatorFinancial from './resources/pt-BR/creator-financial.json';
import ptBRBulkNotifications from './resources/pt-BR/bulk-notifications.json';
import ptBRAdminFinancialOverview from './resources/pt-BR/admin-financial-overview.json';
import ptBRDateRangePicker from './resources/pt-BR/date-range-picker.json';
import ptBRDiscord from './resources/pt-BR/discord.json';
import ptBRMailchimp from './resources/pt-BR/mailchimp.json';
import ptBRPsdTemplates from './resources/pt-BR/psd-templates.json';
import ptBRPsdTutorials from './resources/pt-BR/psd-tutorials.json';
import esCommon from './resources/es/common.json';
import esAuth from './resources/es/auth.json';
import esPacks from './resources/es/packs.json';
import esCategories from './resources/es/categories.json';
import esTags from './resources/es/tags.json';
import esLearnings from './resources/es/learnings.json';
import esProfiles from './resources/es/profiles.json';
import esAnalytics from './resources/es/analytics.json';
import esContracts from './resources/es/contracts.json';
import esHighlights from './resources/es/highlights.json';
import esCollections from './resources/es/collections.json';
import esPayments from './resources/es/payments.json';
import esReceivables from './resources/es/receivables.json';
import esReceivableShareConfigs from './resources/es/receivable-share-configs.json';
import esReceivableSnapshots from './resources/es/receivable-snapshots.json';
import esNavigation from './resources/es/navigation.json';
import esPresets from './resources/es/presets.json';
import esReceivablesComponents from './resources/es/receivables-components.json';
import esPaymentsComponents from './resources/es/payments-components.json';
import esLgpd from './resources/es/lgpd.json';
import esStoreRedirect from './resources/es/store-redirect.json';
import esCreatorFinancial from './resources/es/creator-financial.json';
import esBulkNotifications from './resources/es/bulk-notifications.json';
import esAdminFinancialOverview from './resources/es/admin-financial-overview.json';
import esDateRangePicker from './resources/es/date-range-picker.json';
import esDiscord from './resources/es/discord.json';
import esMailchimp from './resources/es/mailchimp.json';
import esPsdTemplates from './resources/es/psd-templates.json';
import esPsdTutorials from './resources/es/psd-tutorials.json';

// Normalizar código de idioma "pt" para "pt-BR"
const normalizeLanguage = (lng: string): string => {
  if (lng === 'pt' || (lng.startsWith('pt') && lng !== 'pt-BR')) {
    return 'pt-BR';
  }
  return lng;
};

// Normalizar valor no localStorage antes da inicialização
if (typeof window !== 'undefined') {
  const storedLng = localStorage.getItem('i18nextLng');
  if (storedLng) {
    const normalized = normalizeLanguage(storedLng);
    if (storedLng !== normalized) {
      localStorage.setItem('i18nextLng', normalized);
    }
  }
}

i18n
  .use(LanguageDetector) // Detecta o idioma do navegador
  .use(initReactI18next) // Passa i18n para react-i18next
  .init({
    // Recursos de tradução
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        packs: enPacks,
        categories: enCategories,
        tags: enTags,
        learnings: enLearnings,
        profiles: enProfiles,
        analytics: enAnalytics,
        contracts: enContracts,
        highlights: enHighlights,
        collections: enCollections,
        payments: enPayments,
        receivables: enReceivables,
        'receivable-share-configs': enReceivableShareConfigs,
        'receivable-snapshots': enReceivableSnapshots,
        navigation: enNavigation,
        presets: enPresets,
        'receivables-components': enReceivablesComponents,
        'payments-components': enPaymentsComponents,
        lgpd: enLgpd,
        'store-redirect': enStoreRedirect,
        'creator-financial': enCreatorFinancial,
        'bulk-notifications': enBulkNotifications,
        'admin-financial-overview': enAdminFinancialOverview,
        'date-range-picker': enDateRangePicker,
        discord: enDiscord,
        mailchimp: enMailchimp,
        psdTemplates: enPsdTemplates,
        psdTutorials: enPsdTutorials,
      },
      // Adicionar "pt" como alias para "pt-BR" para evitar erro de rejeição
      pt: {
        common: ptBRCommon,
        auth: ptBRAuth,
        packs: ptBRPacks,
        categories: ptBRCategories,
        tags: ptBRTags,
        learnings: ptBRLearnings,
        profiles: ptBRProfiles,
        analytics: ptBRAnalytics,
        contracts: ptBRContracts,
        highlights: ptBRHighlights,
        collections: ptBRCollections,
        payments: ptBRPayments,
        receivables: ptBRReceivables,
        'receivable-share-configs': ptBRReceivableShareConfigs,
        'receivable-snapshots': ptBRReceivableSnapshots,
        navigation: ptBRNavigation,
        presets: ptBRPresets,
        'receivables-components': ptBRReceivablesComponents,
        'payments-components': ptBRPaymentsComponents,
        lgpd: ptBRLgpd,
        'store-redirect': ptBRStoreRedirect,
        'creator-financial': ptBRCreatorFinancial,
        'bulk-notifications': ptBRBulkNotifications,
        'admin-financial-overview': ptBRAdminFinancialOverview,
        'date-range-picker': ptBRDateRangePicker,
        discord: ptBRDiscord,
        mailchimp: ptBRMailchimp,
        psdTemplates: ptBRPsdTemplates,
        psdTutorials: ptBRPsdTutorials,
      },
      'pt-BR': {
        common: ptBRCommon,
        auth: ptBRAuth,
        packs: ptBRPacks,
        categories: ptBRCategories,
        tags: ptBRTags,
        learnings: ptBRLearnings,
        profiles: ptBRProfiles,
        analytics: ptBRAnalytics,
        contracts: ptBRContracts,
        highlights: ptBRHighlights,
        collections: ptBRCollections,
        payments: ptBRPayments,
        receivables: ptBRReceivables,
        'receivable-share-configs': ptBRReceivableShareConfigs,
        'receivable-snapshots': ptBRReceivableSnapshots,
        navigation: ptBRNavigation,
        presets: ptBRPresets,
        'receivables-components': ptBRReceivablesComponents,
        'payments-components': ptBRPaymentsComponents,
        lgpd: ptBRLgpd,
        'store-redirect': ptBRStoreRedirect,
        'creator-financial': ptBRCreatorFinancial,
        'bulk-notifications': ptBRBulkNotifications,
        'admin-financial-overview': ptBRAdminFinancialOverview,
        'date-range-picker': ptBRDateRangePicker,
        discord: ptBRDiscord,
        mailchimp: ptBRMailchimp,
        psdTemplates: ptBRPsdTemplates,
        psdTutorials: ptBRPsdTutorials,
      },
      es: {
        common: esCommon,
        auth: esAuth,
        packs: esPacks,
        categories: esCategories,
        tags: esTags,
        learnings: esLearnings,
        profiles: esProfiles,
        analytics: esAnalytics,
        contracts: esContracts,
        highlights: esHighlights,
        collections: esCollections,
        payments: esPayments,
        receivables: esReceivables,
        'receivable-share-configs': esReceivableShareConfigs,
        'receivable-snapshots': esReceivableSnapshots,
        navigation: esNavigation,
        presets: esPresets,
        'receivables-components': esReceivablesComponents,
        'payments-components': esPaymentsComponents,
        lgpd: esLgpd,
        'store-redirect': esStoreRedirect,
        'creator-financial': esCreatorFinancial,
        'bulk-notifications': esBulkNotifications,
        'admin-financial-overview': esAdminFinancialOverview,
        'date-range-picker': esDateRangePicker,
        discord: esDiscord,
        mailchimp: esMailchimp,
        psdTemplates: esPsdTemplates,
        psdTutorials: esPsdTutorials,
      },
    },
    
    // Idioma padrão
    fallbackLng: 'pt-BR',
    
    // Namespace padrão
    defaultNS: 'common',
    
    // Idiomas suportados - incluir "pt" para evitar rejeição
    supportedLngs: ['en', 'pt', 'pt-BR', 'es'],
    
    // Aceitar códigos de idioma não explícitos e fazer fallback
    nonExplicitSupportedLngs: true,
    
    // Limpar código de idioma (remove região se não suportada)
    cleanCode: true,
    
    // Detecção de idioma
    detection: {
      // Ordem de detecção — apenas escolha explícita do usuário; padrão é pt-BR
      order: ['localStorage'],
      // Cache do idioma selecionado
      caches: ['localStorage'],
      // Chave no localStorage
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Interpolação
    interpolation: {
      escapeValue: false, // React já protege contra XSS
    },
    
    // React
    react: {
      useSuspense: false, // Não usar Suspense (melhor para Vite)
    },
    
    // Debug (apenas em desenvolvimento)
    debug: import.meta.env.DEV,
  });

// Normalizar idioma após inicialização (apenas uma vez, sem loop)
i18n.on('initialized', () => {
  const currentLng = i18n.language;
  const normalizedLng = normalizeLanguage(currentLng);
  if (currentLng !== normalizedLng && ['en', 'pt-BR', 'es'].includes(normalizedLng)) {
    // Atualizar diretamente sem disparar eventos para evitar loop
    i18n.language = normalizedLng;
    if (typeof window !== 'undefined') {
      localStorage.setItem('i18nextLng', normalizedLng);
    }
  }
});

// Interceptar mudanças de idioma para normalizar
const originalChangeLanguage = i18n.changeLanguage.bind(i18n);
(i18n.changeLanguage as any) = (lng: string | string[], callback?: (error: Error | null, t: any) => void) => {
  const normalizedLng = normalizeLanguage(typeof lng === 'string' ? lng : lng[0] || 'pt-BR');
  return originalChangeLanguage(normalizedLng, callback);
};

// Log para debug (apenas em desenvolvimento)
if (import.meta.env.DEV) {
  i18n.on('languageChanged', (lng) => {
    console.log('🌐 Idioma alterado para:', lng);
  });
}

export default i18n;
